export const TOOLBAR_OPTIONS = [
  [{ color: [] }, { background: [] }, { align: [] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ script: 'sub' }, { script: 'super' }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ header: 1 }, { header: 2 }],
  ['link', 'image', 'blockquote']
];
